<template>
  <v-container>
    <h4>
      Request Helper
      <v-btn
        class="mx-2"
        small
        @click="print"
      >
        Print
      </v-btn>
    </h4>
    <v-row>
      <v-col
        cols="12"
        md="12"
        lg="10"
      >
        <!-- start status & helper code -->
        <v-container>
          <v-row>
            <v-col
              cols="4"
              md="2"
            >
              <b>Status:</b>
            </v-col>
            <v-col
              cols="8"
              md="4"
            >
              <v-select
                :items="status_list"
                item-text="label"
                item-value="value"
                label="Status"
                v-model="status_id"
                outlined
                dense
               
              ></v-select>
              <span class="print">
                {{ status_name }}
              </span>
            </v-col>
            <v-col
              cols="4"
              md="2"
             
            >
              <v-btn
                class="mx-2"
                small
                color="orange"
                dark
                @click="updateRequestStatus"
              >
                Update
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="4"
              md="2"
            >
              <b>Issued date:</b>
            </v-col>
            <v-col
              cols="8"
              md="4"
            >
              {{ issued_date }}
            </v-col>
            <v-col
              cols="4"
              md="2"
            >
              <b>Request Helper Code:</b>
            </v-col>
            <v-col
              cols="8"
              md="4"
            >
              {{ request_helper_code || '-' }}
            </v-col>
          </v-row>
        </v-container>
        <!-- end status & helper code -->
        <v-divider></v-divider>
        <!-- start contact-->
        <app-contact
          :contact_name="contact_name"
          :phone_number="phone_number"
          :email="email"
          :line_id="line_id"
        />
        <!-- end contact -->
        <v-divider></v-divider>
        <!-- start location -->
        <app-location
          :request_type="request_type"
          :province_name_en="province_name_en"
          :district_name_en="district_name_en"
          :sub_district_name_en="sub_district_name_en"
          :type_of_building="type_of_building"
          :floor="floor"
          :address_detail="address_detail"
        />
        <!-- end location -->
        <v-divider></v-divider>
        <!-- start driver detail -->
        <div v-show="request_type == 'driver'">
          <app-driver-detail
            :driver="driver"
          />
        </div>
        <!-- end driver detail -->
        <v-divider v-show="request_type == 'driver'"></v-divider>
        <!-- start maid detail -->
        <div v-show="request_type != 'driver'">
          <app-maid-detail
            :maid="maid"
          />
        </div>
        <!-- end maid detail -->
        <v-divider v-show="request_type != 'driver'"></v-divider>
        <div class="text-left no-print">
          <v-btn
            v-if="request_type == 'driver'"
            class="mx-2"
            small
            exact
            :to="{ name: 'request-helper-driver-list' }"
          >
            Back
          </v-btn>
          <v-btn
            v-else
            class="mx-2"
            small
            exact
            :to="{ name: 'request-helper-maid-list' }"
          >
            Back
          </v-btn>
        </div>
      </v-col>
    </v-row>
    <div class="print-area print-hidden-content">
      <div class="contact-area">
        <print-detail
          :request="request_helper"
        />
      </div>
    </div>
  </v-container>
</template>

<script>
import { authHeader } from '../../../_helpers';
import moment from 'moment';
import printHtmlBlock from 'print-html-block';
export default {
  name: 'RequestHelperView',
  components: {
    AppContact: () => import('../components/contact'),
    AppLocation: () => import('../components/location'),
    AppDriverDetail: () => import('../components/driver-detail'),
    AppMaidDetail: () => import('../components/maid-detail'),
    PrintDetail: () => import('../components/print-detail'),
  },
  data: () => ({
    position_list: {
      nanny: 'Nanny',
      maid: 'Maid',
      elder: 'Elder Care',
      driver: 'Driver',
      premium: 'Premium Nanny'
    },
    request_helper: {},
    status_list: [],
    status_id: 0,
    request_id: null,
    request_helper_code: '',
    contact_name: '',
    phone_number: '',
    email: '',
    line_id: '',
    issued_date: '',
    province_id: 0,
    district_id: 0,
    sub_district_id: 0,
    province_name_en: '',
    district_name_en: '',
    sub_district_name_en: '',
    address_detail: '',
    type_of_building: '',
    floor: '',
    request_type: '',
    employer_nationality: '',
    driver: {
      driving_area: '',
      has_car: null,
      car_type: [],
      car_type_other: '',
      car_gear_type: [],
      expect_language: [],
      prefer_age_range: [],
      work_day: [],
      work_time: '',
      any_driver: null,
      is_ot: null,
      expect_salary: [],
      start_hiring: '',
      interview_channel: '',
      replacement_guarantee: ''
    },
    maid: {
      type_of_worker: [],
      work_type: '',
      work_day: [],
      work_day_other: '',
      work_time: '',
      helper_nationality: [],
      expect_language: [],
      expect_language_other: '',
      require_cooking: null,
      cooking_type: '',
      any_kid: null,
      amount_kid: 0,
      age_month: '',
      age_year: '',
      any_pet: null,
      amount_pet: 0,
      type_of_pet: [],
      amount_current_helper: null,
      special_requirement: ''
    },
    province_list: [],
    district_list: [],
    sub_district_list: [],
    job_list: [
      { label: 'Maid', value: 'Maid' },
      { label: 'Nanny', value: 'Nanny' },
      { label: 'Elder Care', value: 'Elder Care' },
      { label: 'Premium nanny', value: 'Premium Nanny' },
      { label: 'Cook', value: 'Cook' },
      { label: 'Pet Care', value: 'Pet' },
      { label: 'Restaurant', value: 'Restaurant' }
    ],
    work_schedule: [
      { label: 'Full-time and live-in', value: 'Full-time and live-in' },
      { label: 'Full-time and live-out', value: 'Full-time and live-out' },
      { label: 'Part-time', value: 'Part-time' },
    ],
    maid_work_day_list: [
      { label: 'Monday - Friday (5 days/week)', value: 'Monday - Friday (5 days/week)' },
      { label: 'Monday - Saturday (6 days/week)', value: 'Monday - Saturday (6 days/week)' },
      { label: 'Monday - Wednesday (3 days/week)', value: 'Monday - Wednesday (3 days/week)' },
      { label: 'Tuesday - Thursday (3 days/week)', value: 'Tuesday - Thursday (3 days/week)' },
      { label: 'Monday & Friday (2 days/week)', value: 'Monday & Friday (2 days/week)' },
      { label: 'Tuesday & Saturday (2 days/week)', value: 'Tuesday & Saturday (2 days/week)' },
      { label: 'Other', value: 'Other' }
    ],
    nationality_list: [
      { label: 'Thai', value: 'Thai' },
      { label: 'Myanmar', value: 'Myanmar' },
      { label: 'Philippine', value: 'Philippine' },
      { label: 'Lao', value: 'Laos' },
      { label: 'Any', value: 'Any' }
    ],
    maid_language_list: [
      { label: 'Speak Thai', value: 'Speak Thai' },
      { label: 'Speak English', value: 'Speak English' },
      { label: 'Other', value: 'Other' }
    ],
    kid_list: [
      { label: '0', value: 0 },
      { label: '1', value: 1 },
      { label: '2', value: 2 },
      { label: '3', value: 3 },
      { label: '4', value: 4 },
      { label: '5', value: 5 },
      { label: '6+', value: 6 }
    ],
    pet_list: [
      { label: '0', value: 0 },
      { label: '1', value: 1 },
      { label: '2', value: 2 },
      { label: '3', value: 3 },
      { label: '4', value: 4 },
      { label: '5', value: 5 },
      { label: '6+', value: 6 }
    ],
    pet_type_list: [
      { label: 'Dog', value: 'Dog' },
      { label: 'Cat', value: 'Cat' },
      { label: 'Maybe Later', value: 'Maybe' }
    ],
    type_of_bulding_list: [
      { label: 'House', value: 'House' },
      { label: 'Condo', value: 'Condo' },
      { label: 'Apartment', value: 'Apartment' },
      { label: 'Hotel and Restaurant', value: 'Hotel and Restaurant' },
      { label: 'Townhouse', value: 'Townhouse' },
      { label: 'Other', value: 'Other' }
    ],
    floor_list: [
      { label: '1', value: 1 },
      { label: '2', value: 2 },
      { label: '3', value: 3 },
      { label: '4', value: 4 },
      { label: '5', value: 5 },
      { label: '6+', value: 6 },
    ],
    is_car_list: [
      { label: 'Yes, already own a car.', value: true },
      { label: 'No, need a car from us.', value: false }
    ],
    car_type_list: [
      { label: 'Sedan', value: 'Sedan' },
      { label: 'SUV', value: 'SUV' },
      { label: 'Van or Minivan', value: 'Van or Minivan' },
      { label: 'Truck or Pick-up', value: 'Truck or Pick-up' },
      { label: 'Other', value: 'Other' },
    ],
    car_gear_type_list: [
      { label: 'Automatic', value: 'Automatic' },
      { label: 'Manual', value: 'Manual' }
    ],
    language_list: [
      { label: 'Speak Thai', value: 'Speak Thai' },
      { label: 'Speak English', value: 'Speak English' },
      { label: 'Speak little English', value: 'Speak little English' }
    ],
    prefer_age_list: [
      { label: '20-30 years old', value: '20-30 years old' },
      { label: '30-40 years old', value: '30-40 years old' },
      { label: '40-50 years old', value: '40-50 years old' },
      { label: 'Any', value: 'Any' }
    ],
    work_day_list: [
      { label: 'Monday', value: 'Monday' },
      { label: 'Tuesday', value: 'Tuesday' },
      { label: 'Wednesaday', value: 'Wednesaday' },
      { label: 'Thurday', value: 'Thurday' },
      { label: 'Friday', value: 'Friday' },
      { label: 'Saturday', value: 'Saturday' },
      { label: 'Sunday', value: 'Sunday' }
    ],
    expect_salary_list: [
      { label: '15,000 to 18,000 Baht', value: '15000 to 18000 Baht' },
      { label: '18,000 to 20,000 Baht', value: '18000 to 20000 Baht' },
      { label: '20,000 Baht Up', value: '20000 Baht Up' },
      { label: 'Any', value: 'Any' }
    ],
    start_hiring_list: [
      { label: 'In 1 to 3 days', value: 'In 1 to 3 days' },
      { label: 'In 7 days', value: 'In 7 days' },
      { label: 'In 14 days', value: 'In 14 days' },
      { label: 'After 14 days', value: 'After 14 days' }
    ],
    interview_channel_list: [
      { label: 'Home Inverview - 300 Baht', value: 'Home Inverview' },
      { label: 'Online Interview (Line / Skype / Zoom) - Free', value: 'Online Interview' },
      { label: 'Office Interview (Sukhumvit soi 61, 26/2) - Free', value: 'Office Interview' },
      { label: 'Try-Out 100 Baht/Hour', value: 'Try-Out' }
    ],
    replacement_list: [
      { label: '10,500 Baht for 3 months 3 times replacement', value: '3 months 3 times replacement' },
      { label: '16,500 Baht for 6 months 6 times replacement', value: '6 months 6 times replacement' },
      { label: '20,500 Baht for 1 year 12 times replacement', value: '1 year 12 times replacement' }
    ]
  }),
  async mounted () {
    this.request_id = this.$route.params.id
    await this.getRequestDetail()
    await this.getRequestHelperStatusList()
  },
  computed: {
    status_name () {
      let status = this.status_list.find(item => {
        return (item.value == this.status_id)
      })
      return (status) ? status.label : '-'
    }
  },
  methods: {
    async getRequestDetail () {
      try {
        const { data } = await this.$http.get(`/back-office/request-helpers/${this.request_id}`, authHeader())
        this.request_helper = data
        this.status_id = data.status_id
        this.contact_name = data.contact_name
        this.phone_number = data.phone_number
        this.email = data.email
        this.line_id = data.line_id
        this.issued_date = moment(String(data.createdAt)).format('DD MMMM, YYYY hh:mm:ss a')
        this.province_id = data.province_id
        this.district_id = data.district_id
        this.sub_district_id = data.sub_district_id
        this.province_name_en = data.province_name_en
        this.district_name_en = data.district_name_en
        this.sub_district_name_en = data.sub_district_name_en
        this.address_detail = data.address_detail
        this.type_of_building = data.type_of_building
        this.floor = data.floor
        this.request_type = data.request_type
        this.request_helper_code = data.request_helper_code
        if (data.request_type == 'driver') {
          let driver = {
            employer_nationality: data.employer_nationality,
            driving_area: data.driving_area,
            has_car: data.has_car,
            car_type: data.car_type ? data.car_type.split(',') : [],
            car_type_other: data.car_type_other,
            car_gear_type: data.car_gear_type ? data.car_gear_type.split(',') : [],
            expect_language: data.expect_language ? data.expect_language.split(',') : [],
            prefer_age_range: data.prefer_age_range ? data.prefer_age_range.split(',') : [],
            work_day: data.work_day ? data.work_day.split(',') : [],
            work_time: data.work_time,
            any_driver: data.any_driver,
            is_ot: data.is_ot,
            expect_salary: data.expect_salary ? data.expect_salary.split(',') : [],
            start_hiring: data.start_hiring,
            interview_channel: data.interview_channel,
            replacement_guarantee: data.replacement_guarantee
          }
          this.driver = driver
          this.request_helper.car_type = driver.car_type
          this.request_helper.car_gear_type = driver.car_gear_type
          this.request_helper.expect_language = driver.expect_language
          this.request_helper.prefer_age_range = driver.prefer_age_range
          this.request_helper.work_day = driver.work_day
          this.request_helper.expect_salary = driver.expect_salary
        } else {
          let maid = {
            employer_nationality: data.employer_nationality,
            type_of_worker: data.type_of_worker ? data.type_of_worker.split(',') : [],
            work_type: data.work_type,
            work_day: data.work_day ? data.work_day.split(',') : [],
            work_day_other: data.work_day_other,
            work_time: data.work_time,
            helper_nationality: data.helper_nationality ? data.helper_nationality.split(',') : [],
            expect_language: data.expect_language ? data.expect_language.split(',') : [],
            expect_language_other: data.expect_language_other,
            require_cooking: data.require_cooking,
            cooking_type: data.cooking_type,
            any_kid: data.any_kid,
            amount_kid: data.amount_kid,
            age_month: data.age_month,
            age_year: data.age_year,
            any_pet: data.any_pet,
            amount_pet: data.amount_pet,
            type_of_pet: data.type_of_pet ? data.type_of_pet.split(',') : [],
            amount_current_helper: data.amount_current_helper,
            special_requirement: data.special_requirement
          }
          this.maid = maid
          this.request_helper.type_of_worker = maid.type_of_worker
          this.request_helper.work_day = maid.work_day
          this.request_helper.helper_nationality = maid.helper_nationality
          this.request_helper.expect_language = maid.expect_language
          this.request_helper.type_of_pet = maid.type_of_pet
        }
      } catch (err) {
        console.log(err)
        alert('Something went wrong')
      }
    },
    async getRequestHelperStatusList () {
      try {
        const { data } = await this.$http.get('/back-office/request-helper-status?limit=50&sortby=status_name&ordering=ASC', authHeader())
        data.forEach(item => {
          this.status_list.push({ label: item.status_name, value: item.id })
        });
      } catch (err) {
        console.log(err)
        alert('Something went wrong')
      }
    },
    async updateRequestStatus () {
      try {
        if (this.status_id) {
          await this.$http.put(`/back-office/request-helpers/${this.request_id}/status/${this.status_id}`, null, authHeader())
        }
      } catch (err) {
        console.log(err)
        alert('Something went wrong')
      }
    },
    print() {
      printHtmlBlock('.print-area', { importStyle: true });
    }
  }
}
</script>

<style scoped>
.print-hidden-content {
  display: none;
}
@media print {
  .print-hidden-content {
    display: block;
  }
}
</style>
